import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, CircleSlash } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";

/**
 * Where eSemneaza sends the participant after signing or declining.
 *
 * Says what happens next and nothing about the contract itself: the URL is
 * public and carries no token, so the page can know nothing about who is
 * looking at it — the signed copy arrives by email from eSemneaza once FPED
 * has signed too.
 */
const COPY = {
  signed: {
    icon: <CheckCircle2 size={30} />,
    accent: "bg-[#E7F4ED] text-[#1F7A3D] border-[#1F7A3D]/20",
    title: "Mulțumim! Contractul a fost semnat.",
    body: "Urmează semnătura Fundației. Contractul semnat de ambele părți îți va veni pe email. Nu mai trebuie să faci nimic.",
  },
  declined: {
    icon: <CircleSlash size={30} />,
    accent: "bg-[#EDEEF0] text-[#373A45] border-[#E5E7EB]",
    title: "Ai refuzat semnarea contractului.",
    body: "Dacă a fost o greșeală sau ai întrebări despre contract, scrie-ne la contact@fped.org și îți trimitem contractul din nou.",
  },
};

export default function ContractReturn({ variant = "signed" }) {
  const c = COPY[variant] || COPY.signed;
  return (
    <div className="min-h-screen bg-[#F5F6F6] flex flex-col">
      <Header />
      <main className="flex-1 grid place-items-center px-4 py-12" data-testid={`contract-return-${variant}`}>
        <article className="w-full max-w-xl rounded-3xl bg-white border border-[#E5E7EB] shadow-sm p-8 md:p-12 text-center">
          <div className={`mx-auto w-16 h-16 rounded-full grid place-items-center border ${c.accent}`}>{c.icon}</div>
          <h1 className="mt-6 text-2xl md:text-3xl font-semibold text-[#373A45]">{c.title}</h1>
          <p className="mt-3 text-sm md:text-base text-[#6B7280] leading-relaxed">{c.body}</p>
          <div className="mt-8">
            <Link to="/" className="inline-flex items-center justify-center rounded-full px-6 py-3 text-sm font-semibold bg-[#965EA7] text-white hover:bg-[#7d4990] transition-colors">
              Înapoi pe site
            </Link>
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}
